import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { AdmiralService } from '@/services/admiral.service';
import { ref, toRefs, inject } from 'vue';

// Incoming props

export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  props: { anchorClass: String },
  setup(__props) {

const props = __props;



// get back prop values
const { anchorClass } = toRefs(props);

// use the admiral service
const admiralService: AdmiralService | undefined = inject('AdmiralService');
// determine if we can show the link or not
const showLoginLink = ref(false);

// check if we can show the login or not on this page
admiralService?.checkUserSubscribed().then((subscription) => {
    showLoginLink.value = !subscription.isSubscribed;
});

// when the user clicks on the login button
const loginAdmiralUser = () => admiralService?.showUserLogin();

return (_ctx: any,_cache: any) => {
  return (showLoginLink.value)
    ? (_openBlock(), _createElementBlock("a", {
        key: 0,
        href: "#",
        class: _normalizeClass(_unref(anchorClass)),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (loginAdmiralUser()))
      }, [
        _renderSlot(_ctx.$slots, "default")
      ], 2))
    : _createCommentVNode("", true)
}
}

})